import React from "react";
import { RadioGroup } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import {
  KYC_TYPE,
  PAGE_SECTIONS_KEYS,
} from "../../constants/OfferingPageSectionsKeys.constants";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { useParams } from "react-router-dom";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import classnames from "classnames";
import {
  EXLY_SCHEDULELIST__RESET_LIVE_OFFERINGS,
  EXLY_SCHEDULELIST__RESET_SOLDOUT_OFFERINGS,
} from "ui/pages/schedule/redux/actions";
import { useDispatch } from "react-redux";
import { FEATURE_KEYS } from "features/Account/modules/Features/constants/FeatureKeys.constants";
import { navigateTo } from "utils/urlUtils";
import { app_route_keys } from "constants/urlPaths";
import { FEATURE_SECTION_KEY } from "features/Account/modules/Features/constants/Features.constants";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { getKYCTypeOptions } from "../../utils/useOfferingPageSectionUtils";

export const KYCTypeSubsection = withComponentLibraryTheme(
  ({ subSectionKey, endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL }) => {
    const isListingLevel =
      endPoint == UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL;
    const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
    const subSectionConfig = sectionConfig[subSectionKey] || {};
    const { value: selectedStatus } = subSectionConfig;
    const { listing_uuid } = useParams();
    const dispatch = useDispatch();

    const isKRAInaccesible =
      sectionConfig?.[PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED]?.status ==
      FEATURE_STATUS.HIDDEN;

    const { handleSectionChange } = useAccountSectionUnlocking();
    const setSectionConfig = useAdminPanelStore(
      (state) => state.setSectionConfig
    );

    const showRequestVerificationForKRA = isListingLevel && isKRAInaccesible;

    const handleChange = ({ value }) => {
      const payload = {
        listing_uuid,
        feature_key: subSectionKey,
        feature_value: value,
      };
      handleSectionChange({
        endPoint,
        payload,
      });

      // Toggle other KYC type options
      if (value === KYC_TYPE.ESIGN) {
        const key = isListingLevel
          ? PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED
          : FEATURE_KEYS.KRA_FLOW;
        setSectionConfig({
          [key]: {
            value: false,
            status: sectionConfig[key]?.status,
          },
        });
      } else if (value === KYC_TYPE.KRA) {
        setSectionConfig({
          [PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED]: {
            value: false,
            status: sectionConfig[PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED]?.status,
          },
        });
      }

      dispatch({ type: EXLY_SCHEDULELIST__RESET_LIVE_OFFERINGS });
      dispatch({ type: EXLY_SCHEDULELIST__RESET_SOLDOUT_OFFERINGS });
    };

    return (
      <div>
        <RadioGroup
          options={getKYCTypeOptions(sectionConfig)}
          selected={getKYCTypeOptions(sectionConfig).find(
            ({ value }) => value === selectedStatus
          )}
          onChange={handleChange}
          formControlLabelClassName={classnames(
            "!tw-whitespace-nowrap",
            "tw-text-sm md:tw-text-base"
          )}
        />
        {showRequestVerificationForKRA && (
          <div
            onClick={() => {
              navigateTo(app_route_keys.FEATURES, {
                queryParams: { section_key: FEATURE_SECTION_KEY },
              });
            }}
            className="tw-flex tw-border tw-border-[rgb(15,97,156)] tw-text-[rgb(15,97,156)] tw-bg-[#eef8ff] tw-border-solid tw-h-fit tw-items-center tw-justify-center tw-rounded tw-p-[6px_12px] tw-cursor-pointer tw-text-[12px] tw-font-medium tw-leading-normal"
          >
            Request Verification for KRA Workflow
          </div>
        )}
      </div>
    );
  }
);
